export const ADD_GRADE_REQUEST = 'ADD_GRADE_REQUEST'
export const ADD_GRADE_SUCCESS = 'ADD_GRADE_SUCCESS'
export const ADD_GRADE_FALIURE = 'ADD_GRADE_FALIURE'
